import angular from "angular";
import {
  MultipleMachineChangeChildStateServiceProvider,
  vsMultiServiceName as MultipleMachineChangeChildStateServiceName,
  MachineChangeMultipleComponentOptions,
  vsMultiComponentName as MachineChangeMultipleComponentName,
  SingleMachineChangeChildStateServiceProvider,
  vsSingleServiceName as SingleMachineChangeChildStateServiceName,
  MachineChangeSingleComponentOptions,
  vsSingleComponentName as MachineChangeSingleComponentName,
} from "./components/machineChange";
import {
  machineDetailsTabsComponentOptions,
  MachineDetailTabsProvider,
  vsName as machineDetailsTabsComponentOptionsName,
  vsServiceName as machineDetailTabsServiceName,
} from "./components/views/machines/detail/tabs";
import {
  conversionModalComponentOptions,
  ConversionModalService,
  vsName as conversionModalComponentOptionsName,
  vsServiceName as conversionModalServiceName,
} from "./components/conversionModal";
import {
  machineDetailComponentOptions,
  vsComponentName as MachineDetailComponentName,
} from "./components/views/machines/detail/component";
import {
  machineDetailConfigurationViewDirective,
  vsComponentName as machineDetailConfigurationViewComponentName,
} from "./components/views/machines/detail/views/configurations";
import {
  MachinesChangeViewComponentOptions,
  MachinesChangeViewModalService,
  vsComponentName as MachinesChangeViewComponentName,
  vsServiceName as MachinesChangeViewModalServiceName,
} from "./components/changeDetailsModel";

import { vsName as reportingModuleName } from "../../reporting";
import {
  machineConfigurationViewComponentOptions,
  vsComponentName as machineConfigurationViewComponentName,
} from "./components/machineConfigurationView";
import { configSelectMachineFormlyType } from "./ui-formly/types/selectMachine/config";
import { vsModuleName as SelectMachineModalModuleName } from "./components/selectMachineModal";
import { configureLookupManagement } from "../../records/lookup/lookupManagement/config";
import {
  vsLookupManagementServiceName,
  vsLookupManagementServiceProviderName,
} from "./lookups";
import { vsModuleName as lookupModuleName } from "../../records/lookup/module";

export const vsModuleName = "SlotTrak.Machines.Shared";

const module = angular
  .module(vsModuleName, [
    reportingModuleName,
    lookupModuleName,
    SelectMachineModalModuleName,
  ])
  .provider(
    MultipleMachineChangeChildStateServiceName,
    MultipleMachineChangeChildStateServiceProvider
  )
  .provider(machineDetailTabsServiceName, MachineDetailTabsProvider)
  .provider(
    SingleMachineChangeChildStateServiceName,
    SingleMachineChangeChildStateServiceProvider
  )
  .component(MachineDetailComponentName, machineDetailComponentOptions)
  .component(
    machineDetailsTabsComponentOptionsName,
    machineDetailsTabsComponentOptions
  )
  .component(
    conversionModalComponentOptionsName,
    conversionModalComponentOptions
  )
  .component(
    MachineChangeMultipleComponentName,
    MachineChangeMultipleComponentOptions
  )
  .component(
    MachineChangeSingleComponentName,
    MachineChangeSingleComponentOptions
  )
  .directive(
    machineDetailConfigurationViewComponentName,
    machineDetailConfigurationViewDirective
  )
  .service(conversionModalServiceName, ConversionModalService)
  .service(MachinesChangeViewModalServiceName, MachinesChangeViewModalService)
  .component(
    MachinesChangeViewComponentName,
    MachinesChangeViewComponentOptions
  )
  .component(
    machineConfigurationViewComponentName,
    machineConfigurationViewComponentOptions
  )
  .config(configSelectMachineFormlyType);

configureLookupManagement(module, {
  baseStateSref: "main.machines.lookups",
  lookupManagementServiceName: vsLookupManagementServiceName,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
